const ReportList = () =>
  import("@/components/atm-front/cases/case/Reports/ReportList/ReportList.vue");
const AcousticMeasuresStepper = () =>
  import("@/components/atm-front/cases/case/Reports/AcousticMeasuresStepper/AcousticMeasuresStepper.vue");

const AcousticAttestationStepper = () =>
  import("@/components/atm-front/cases/case/Reports/AcousticAttestationStepper/AcousticAttestationStepper.vue");

export default [
  {
    path: "",
    name: "ReportList",
    component: ReportList,
  },
  {
    path: "acoustic-measures/:reportTemplateUuid",
    name: "AcousticMeasuresStepper",
    component: AcousticMeasuresStepper,
  },
  {
    path: "acoustic-attestation/:reportTemplateUuid",
    name: "AcousticAttestationStepper",
    component: AcousticAttestationStepper,
  },
];
